import { render, staticRenderFns } from "./UserAdmin.vue?vue&type=template&id=b4c3c220&scoped=true"
import script from "./UserAdmin.vue?vue&type=script&lang=js"
export * from "./UserAdmin.vue?vue&type=script&lang=js"
import style0 from "./UserAdmin.vue?vue&type=style&index=0&id=b4c3c220&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c3c220",
  null
  
)

export default component.exports